module.exports = __webpack_public_path__ + "img/icon_tickets.f7bf35ce.png";